module.exports = __webpack_public_path__ + "static/media/levels_4_4.6574d039.svg";